const getNewComment = (args) => {
  return {
    id: args.id,
    element_type: "App\\Models\\MasterClubPostGroup",
    element_id: args.element_id,
    content: args.content,
    is_enabled: true,
    is_checked: false,
    created_at: args.created_at,
    likes_count: 0,
    reports_count: 0,
    replies_count: 0,
    liked: false,
    created_by: {
      id: args.user.id,
      name: args.user.name,
      surname: args.user.surname,
      avatar: args.user.avatar,
      fullname: args.user.fullname,
    },
  };
};

const getNewReply = (args) => {
  return {
    id: args.id,
    element_type: "App\\Models\\MasterClubComment",
    element_id: args.element_id,
    content: args.content,
    is_enabled: true,
    is_checked: false,
    created_at: args.created_at,
    likes_count: 0,
    reports_count: 0,
    liked: false,
    created_by: {
      id: args.user.id,
      name: args.user.name,
      surname: args.user.surname,
      avatar: args.user.avatar,
      fullname: args.user.fullname,
    },
  };
};

function createFakeComment(state, action) {
  const newComment = getNewComment(action.meta.arg);

  const commentsArr = state.getPost?.data?.comments?.data;
  if (Array.isArray(commentsArr)) {
    commentsArr.unshift(newComment);
  }
}

function updateRepliesCountComment(state, action, value) {
  const replies = state.getCommentAndReplies?.data?.replies;
  if (replies && typeof replies.total === "number") {
    replies.total += value;
  }

  const commentsArr = state.getPost?.data?.comments?.data;
  const commentInPostIndex = Array.isArray(commentsArr)
    ? commentsArr.findIndex(
        (comment) => comment.id === action.meta.arg.element_id,
      )
    : -1;

  if (commentInPostIndex >= 0) {
    const current = commentsArr[commentInPostIndex];
    current.replies_count = (current.replies_count || 0) + value;
  }
}

const increaseRepliesCountComment = (state, action) =>
  updateRepliesCountComment(state, action, 1);
const decreaseRepliesCountComment = (state, action) =>
  updateRepliesCountComment(state, action, -1);

function createFakeReply(state, action) {
  const newReply = getNewReply(action.meta.arg);

  const repliesArr = state.getCommentAndReplies?.data?.replies?.data;
  if (Array.isArray(repliesArr)) {
    repliesArr.unshift(newReply);
  }
}

function replaceFakeReplyforReal(state, action) {
  const repliesArr = state.getCommentAndReplies?.data?.replies?.data;
  if (!Array.isArray(repliesArr)) return;

  const newReplyIndex = repliesArr.findIndex(
    (reply) => reply.id === action.meta.arg.id,
  );
  if (newReplyIndex < 0) return;

  repliesArr[newReplyIndex] = {
    ...action.payload.comment,
    is_enabled: true,
    is_checked: false,
    likes_count: 0,
    reports_count: 0,
  };
}

function deleteFakeReply(state, action) {
  const repliesArr = state.getCommentAndReplies?.data?.replies?.data;
  if (!Array.isArray(repliesArr)) return;

  state.getCommentAndReplies.data.replies.data = repliesArr.filter(
    (reply) => reply.id !== action.meta.arg.id,
  );
}

export const replyCommentFunctions = {
  createFakeReply,
  replaceFakeReplyforReal,
  deleteFakeReply,
  increaseRepliesCountComment,
  decreaseRepliesCountComment,
};

const commentFunctions = { createFakeComment };
export default commentFunctions;
